import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import PersonIcon from "@material-ui/icons/Person";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders, handleApiResponse } from '../../assets/helpers/apiHelper.jsx';

class OrganizationProvider extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      userId: sessionStorage.getItem('userId'),
      organizationProviders: [{ firstName: 'loading...', middleName: 'loading...', lastName: 'loading...',
                                suffix: 'loading...', title: 'loading...' }],
      inputDisabled: true,
      submitButtonText: 'loading...'
    };
  }

  handleProviderChange = (idx, field) => (event) => {
    const newOrganizationProviders = this.state.organizationProviders.map((organizationProvider, sidx) => {
      if (idx !== sidx) return organizationProvider;
      if (field === 'firstName') return { ...organizationProvider, firstName: event.target.value };
      if (field === 'middleName') return { ...organizationProvider, middleName: event.target.value };
      if (field === 'lastName') return { ...organizationProvider, lastName: event.target.value };
      if (field === 'suffix') return { ...organizationProvider, suffix: event.target.value };
      if (field === 'title') return { ...organizationProvider, title: event.target.value };
      return null
    });

    this.setState({ organizationProviders: newOrganizationProviders });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    //validate fields
    this.setState({
      inputDisabled: true,
      submitButtonText: 'updating'
    })
    var alertMessage = '';
    for (var key in this.state.organizationProviders) {
      var organizationProvider = this.state.organizationProviders[key]
      var rowNum = parseInt(key, 10)+1;
      if (organizationProvider['firstName'] || organizationProvider['lastNmae']) {
        if (!organizationProvider['firstName']) {
          alertMessage += 'Please add a first name to row ' + rowNum + '.\n';
        }
        if (!organizationProvider['lastName']) {
          alertMessage += 'Please add a last name to row ' + rowNum + '.\n';
        }
      }
    }

    if (alertMessage) {
      this.setState({
        inputDisabled: false,
        submitButtonText: 'Update Providers'
      })
      alertMessage = 'YOUR CHANGES HAVE NOT BEEN SAVED.\nPLEASE FIX THE FOLLOWING ERRORS AND UPDATE AGAIN:\n\n' + alertMessage
      alert(alertMessage)
    } else {

      const organizationProvidersData = {
        userId: this.state.userId,
        organizationProviders: JSON.stringify(this.state.organizationProviders)
      }
      axios.post(`${API_ROOT}/organizationProvider/`, organizationProvidersData, { headers: getApiHeaders() })
        .then(res => this.handleSubmitResponse(res));
    }
  }

  handleSubmitResponse(res) {
    if (this._isMounted) {
      handleApiResponse(res)
      if (res.data.message === 'success') {
        this.getOrganizationProviders()
      } else {
        var alertMessage = '';
        if (res.data.message) {
          alertMessage = res.data.message
        } else {
          alertMessage = 'An unknown error occurred.'
        }
        alert(alertMessage)
      }
    }
  }

  handleAddOrganizationProvider = () => {
    this.setState({ organizationProviders: this.state.organizationProviders.concat([{ id: '', firstName: '',
                                                                                      middleName: '', lastName: '',
                                                                                      suffix: '', title: '' }]) });
  }

  componentDidMount(){
    this._isMounted = true;
    this.getOrganizationProviders()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getOrganizationProviders() {
    axios.get(`${API_ROOT}/organizationProvider/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
      .then(res => this.setOrganizationProviders({responseMessage: res.data}));
  }

  setOrganizationProviders(res) {
    if (this._isMounted) {
      this.setState({
        organizationProviders: res.responseMessage,
        inputDisabled: false,
        submitButtonText: 'Update Providers'
      })
      this.handleAddOrganizationProvider() //add a blank row at the end
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <PersonIcon />
            </CardIcon>
            <h4 id="organizationProvidersHeader" className={classes.cardIconTitle}>
              Providers - <small>add, update or remove providers</small>
            </h4>
          </CardHeader>
          <CardBody>

            {this.state.organizationProviders.map((organizationProvider, idx) => (
              <GridContainer key={idx}>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="first name"
                    type="text"
                    id={"firstName_" + idx}
                    inputProps={{
                      onChange: this.handleProviderChange(idx, 'firstName'),
                      value: organizationProvider.firstName,
                      disabled: this.state.inputDisabled
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="middle name"
                    type="text"
                    id={"middleName_" + idx}
                    inputProps={{
                      onChange: this.handleProviderChange(idx, 'middleName'),
                      value: organizationProvider.middleName,
                      disabled: this.state.inputDisabled
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="last name"
                    type="text"
                    id={"lastName_" +idx}
                    inputProps={{
                      onChange: this.handleProviderChange(idx, 'lastName'),
                      value: organizationProvider.lastName,
                      disabled: this.state.inputDisabled
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    labelText="suffix"
                    type="text"
                    id={"suffix_" + idx}
                    inputProps={{
                      onChange: this.handleProviderChange(idx, 'suffix'),
                      value: organizationProvider.suffix,
                      disabled: this.state.inputDisabled
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="title"
                      type="text"
                      id={"title_" + idx}
                      inputProps={{
                        onChange: this.handleProviderChange(idx, 'title'),
                        value: organizationProvider.title,
                        disabled: this.state.inputDisabled
                      }}
                    />
                </GridItem>
              </GridContainer>
            ))}
            <GridItem xs={12} sm={12} md={6}>
              To delete a provider, remove both the first and last names, then click "update provider."
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <Button
                round
                onClick={this.handleAddOrganizationProvider}
                color="cirrusBlue"
                disabled={this.state.inputDisabled}
                id="addRowButton"
              >
                Add row
              </Button>
              <Button
                round
                color="cirrusBlue"
                type="submit"
                disabled={this.state.inputDisabled}
                id="addOrganizationProviderButton"
              >
                {this.state.submitButtonText}
              </Button>
            </GridItem>
          </CardBody>
        </Card>
      </form>
    )

  }


}

export default withStyles(userProfileStyles)(OrganizationProvider);